namespace GeniuzPOS.Inventory {
    export class IcStockSetAssembleDtColumns {
        static columnsKey = 'Inventory.IcStockSetAssembleDt';
    }
}
